<template>
  <div class="flux-container thales-container" id="thales-container">
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      {{error}}
    </div>

    <div v-if="isLoading">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
      Chargement...
    </div>
    <div v-if="!isLoading">
      <div v-if="!isUserThalesAdmin()" class="red-bin large-screen">
        <div
          class="flux-header"
          v-b-tooltip.hover.bottom="'Contenant les pièces ayant un defaut de qualité'"
        >
          <div class="flux-name"> BAC ROUGE </div>
          <div>

            <span class="redbin-leadtime" style="color : #777877">min: {{ redBinKanbans[redbinStatsPeriodChoose].minLeadTime ? redBinKanbans[redbinStatsPeriodChoose].minLeadTime : ' --'}}</span>
            <span class="avg-lead-time">Lead Time : {{ redBinKanbans[redbinStatsPeriodChoose].leadTimeAvg ? redBinKanbans[redbinStatsPeriodChoose].leadTimeAvg : ' --'}}</span>
            <span class="redbin-leadtime" style="color : #777877">max: {{ redBinKanbans[redbinStatsPeriodChoose].maxLeadTime ? redBinKanbans[redbinStatsPeriodChoose].maxLeadTime : ' --'}}</span>
          </div>
          <div class='ml-lg-auto stats-choice'>
            <b-form-group class="mb-0">
              <b-form-radio-group
                v-model="redbinStatsPeriodChoose"
                :options="redBinStatsPeriod"
                button-variant="outline-primary"
                size="sm"
                buttons
              >
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <div class="red-bin-main">
          <div class="row mx-1 no-gutters d-flex align-items-center" >
            <div class="columns-display-kb" v-for="(columnsOfKb, idx) in redbinKanbanInColumns" :key="idx">
              <div
                v-for="(kanban, index) in columnsOfKb"
                :key="index"
                @click="goToTracking(kanban)"
                @contextmenu.prevent.stop="handleClick($event, kanban)"
                class="clickable"

              >
                <div class="kanban-card clickable mb-1 andon kanban ">
                  <div class="kanban-card-id text-white">
                    <div>{{ chunk(kanban.code, 3) }} <span v-if="kanban.code_gex !== '' && kanban.code_gex !== null" class="styleGex"> - {{ chunk(kanban.code_gex.substr(3, kanban.code_gex.length -1), 6) }} </span></div>
                    <div v-if="kanban.sdcd" class="sdcd-pill"></div>
                  </div>
                  <div class="kanban-andon-duration" :class="kanban.last_workstation == 'Emballage' ? 'first-step-bin' : ''">
                    {{ getTime(kanban.leadTime*60) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(flux, index) in fluxList" :key="index"
        :class="!isUserThalesAdmin() ? 'flux-block large-screen' : ''"
      >
        <div
          :class="fluxData[flux.name].stations.length < 6 ? 'd-flex small-flux' : ''"
        >
          <div :class="!isUserThalesAdmin() ? 'border-for-large' : '' ">
            <div v-if="displayVue">
              <loop-data
                :flux="flux"
                :fluxData="fluxData[flux.name]"
                :ref="'loop-' + flux.name"
                @loop-name-modal-closed="updateLoop"
                @loop-settings-modal-closed="updateData"
              />
              <stations-data
                :stationsList="fluxData[flux.name].stations"
                :flux="flux"
                :ref="'stations-' + flux.name"
                @edit-document-modal-close="emitDocEdition"
                @document-scan-modal-close="emitDocScanUpated"
                @cancel-modal="emitResetDisable"
              />
            </div>
          </div>
          <div v-if="flux.name === 'france' && isUserThalesAdmin()" class="red-bin">
            <div
              class="flux-header"
              v-b-tooltip.hover.bottom="'Contenant les pièces ayant un defaut de qualité'"
            >
              <div> BAC ROUGE </div>
              <div>
                <span class="redbin-leadtime">min: {{ redBinKanbans[redBinStatsPeriodObj.value].minLeadTime ? redBinKanbans[redBinStatsPeriodObj.value].minLeadTime : ' --'}}</span>
                <span class="redbin-leadtime">Lead Time : {{ redBinKanbans[redBinStatsPeriodObj.value].leadTimeAvg ? redBinKanbans[redBinStatsPeriodObj.value].leadTimeAvg : ' --'}}</span>
                <span class="redbin-leadtime">max: {{ redBinKanbans[redBinStatsPeriodObj.value].maxLeadTime ? redBinKanbans[redBinStatsPeriodObj.value].maxLeadTime : ' --'}}</span>
              </div>
              <div>
                <b-dropdown
                  variant="outline-light"
                  :text="redBinStatsPeriodObj.text"
                  size="sm"
                >
                  <b-dropdown-item
                    v-for="(period, index) in redBinStatsPeriod" :key="index"
                    @click="redBinStatsPeriodObj = period"
                  >
                    {{period.text}}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="red-bin-main">
              <div class="row mx-1 no-gutters d-flex align-items-center" v-if="displayVue">
                <div
                  v-for="(kanban, index) in redBinKanbans.cards"
                  :key="index"
                  @click="goToTracking(kanban)"
                  @contextmenu.prevent.stop="handleClick($event, kanban)"
                  class="mx-1 col-5 col-lg-10 col-xl-10 clickable"
                >
                  <div class="kanban-card clickable mb-1 andon text-white">
                    <div class="kanban-card-id text-white">
                      <div>{{ chunk(kanban.code, 3) }} <span v-if="kanban.code_gex !== '' && kanban.code_gex !== null" class="styleGex"> - {{ chunk(kanban.code_gex.substr(3, kanban.code_gex.length -1), 6) }} </span></div>
                      <div v-if="kanban.sdcd" class="sdcd-pill"></div>
                    </div>
                    <div class="kanban-andon-duration" :class="kanban.last_workstation == 'Emballage' ? 'first-step-bin' : ''">
                      {{ getTime(kanban.leadTime*60) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <scan-modal
      ref="scan-modal"
      @document-scan-modal-close="emitDocScanUpated"
      @cancel-modal="emitResetDisable"
    />
    <edit-document-modal
      ref="edit-document-modal"
      @edit-document-modal-close="emitDocEdition"
      @cancel-modal="emitResetDisable"
    />
    <!-- context menu redbin-->
    <vue-simple-context-menu
      :elementId="'context-menu-'  + 'redbin'"
      :options="contextMenuList"
      :ref="'vueSimpleContextMenu'"
      @option-clicked="optionClicked"
    />
  </div>
</template>
<script>
import server from '../api/server.vue'
import Vue from 'vue'
import StationsData from './StationsData.vue'
import ScanModal from './ScanModal.vue'
import EditDocumentModal from './EditDocumentModal.vue'
import LoopData from './LoopData.vue'
import _ from 'lodash'
import moment from 'moment'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import ZebraPrinter from '../core/services/ZebraPrinter.js'
import ToggleNavBar from './ToggleNavBar.vue'


export default {
  name: 'NewHippodrome',
  components: {
    'stations-data': StationsData,
    'loop-data': LoopData,
    'scan-modal': ScanModal,
    'edit-document-modal': EditDocumentModal,
    'vue-simple-context-menu': VueSimpleContextMenu,
    'toggle-navbar': ToggleNavBar,
  },
  data() {
    return {
      statsDisplay: {
        france: false,
        union_europeenne: false,
        grand_export: false
      },
      display: 'display',
      isLoading: true,
      error: false,
      fluxList: [],
      fluxData: {},
      redBinKanbans: {
        lastYearLeadTime: {},
        lastMonthLeadTime: {},
        lastWeekLeadTime: {},
        cards: [],
      },
      zebraPrinter : new ZebraPrinter(),
      contextMenuList: [
        {
        name: 'Imprimer l\'étiquette',
        slug: 'print',
        class: 'print',
        },
        {
        name: 'Editer le document',
        slug: 'edit',
        class: 'edit',
        },
        {
        name: 'Changer de station',
        slug: 'scan',
        class: 'scan',
        },
      ],
      redBinStatsPeriod: [
        {text: 'Dernière année', value: 'lastYearLeadTime'},
        {text: 'Dernier mois', value: 'lastMonthLeadTime'},
        {text: 'Dernière semaine', value: 'lastWeekLeadTime'}],
      redbinStatsPeriodChoose: 'lastYearLeadTime',
      redBinStatsPeriodObj: {text: 'Dernière année', value: 'lastYearLeadTime'},
      displayVue: true,
    }
  },
  methods: {
    printWithBrother (document) {
      const data = [{ CODE: document.code }]
      printHeureServer.printDocument(data).then(() => {
        this.$toasted.success("Etiquette imprimée!")
      }).catch((error) => {
        this.$toasted.error(`Erreur d'impression ! ${error}`)
      })
    },
    printWithZebra (document) {
      var cmds =  `^XA~TA000~JSN^LT0^MNW^MTT^PON"
      ^PMN^LH0,0^JMA^PR6,6~SD15^JUS
      ^LRN^CI27^PA0,1,1,0^XZ^XA^MMT^PW609^LL405
      ^LS0
      ^BY3,3,195^FT26,287^BCN,,Y,N^FH\^FD${document.code}^FS
      ^FT204,353^A0N,32,33^FH\^CI28^FD${document.description}^FS^CI27
      ^FT250,67^A0N,36,35^FH\^CI28^FD${document.flux}^FS^CI27^PQ1,0,1,Y^XZ`
      this.zebraPrinter.send(cmds).then((result) => {
        // this.documentPrinted = true
        this.$toasted.success("Etiquette imprimée!")
      }).catch((error) => {
        this.$toasted.error(`Impossible d'imprimer ...<br>Êtes-vous connecté à l'imprimante zebra ?`)
        console.error(error)
      })
    },
    printDocument (document) {
      if (!localStorage.getItem('printer_type')) {
        this.printWithBrother(document)
      } else if (localStorage.getItem('printer_type') === 'zebra' ||
        this.isUserThales())
      {
        this.printWithZebra(document)
      } else {
        this.printWithBrother(document)
      }
    },
    showEditDocumentModal(document) {
      this.$refs['edit-document-modal'].showModal(document)
    },
    showScanModal(document) {
      this.$refs['scan-modal'].showModal(document)
    },
    optionClicked (event) {
      const option = event.option.slug
      const document = event.item
      if (option === 'print') {
        this.printDocument(document)
      } else if (option === 'scan') {
        document.disable = true
        this.showScanModal(document)
      } else if (option === 'edit') {
        document.disable = true
        this.showEditDocumentModal(document)
      }
    },
    handleClick (event, item) {
      if (!item.disable) {
        this.$refs.vueSimpleContextMenu.showMenu(event, item)
      }
    },
    emitDocScanUpated (scanInfo) {
      let cardUpdate = null
      if (scanInfo.oldWorkstation === 'Red bin') {
        this.redBinKanbans.cards.filter( card => {
          if (card.code !== scanInfo.code){
            return card 
          }
        })
      } else {
        for (const station of this.fluxData[scanInfo.loop].stations) {
          if (station.name === scanInfo.oldWorkstation) {
            station.kanbanCards.filter( card => {
              if (card.code !== scanInfo.code) {
                return card
              } else {
                cardUpdate = card
              }
            })
          }
        }
      }
      if (scanInfo.workstation !== 'Red bin') {
        for (const station of this.fluxData[scanInfo.loop].stations) {
          if (station.name === scanInfo.workstation) {
            station.kanbanCards.push(cardUpdate)
            this.$nextTick(() => {
              cardUpdate.disable = false
            })
          }
        }
      } else {
        this.redBinKanbans.cards.push(cardUpdate)
        this.$nextTick(() => {
          cardUpdate.disable = false
        })
      }
      this.$toasted.success('Modifications réalisées, elle s\'afficheront dans quelques secondes')
    },
    emitDocEdition (editionInfo) {
      let cardUpdate = null
      if (editionInfo.oldCode !== editionInfo.newCode) {
        if (editionInfo.oldLoop === editionInfo.newLoop) {
          for (const station of this.fluxData[editionInfo.oldLoop].stations) {
            if (station.name === editionInfo.oldWorkstation) {
              for (const card of station.kanbanCards) {
                if (card.code === editionInfo.oldCode) {
                  card.code = editionInfo.newCode
                }
              }
            }
          }
        } else {
          for (const station of this.fluxData[editionInfo.oldLoop].stations) {
            if (station.name === editionInfo.oldWorkstation) {
              station.kanbanCards.filter( card => {
                if (card.code !== editionInfo.oldCode) {
                  return card
                } else {
                  cardUpdate = card
                }
              })
            }
          }
          this.fluxData[editionInfo.newLoop].stations[0].kanbanCards.push(cardUpdate)
          this.$nextTick(() => {
            cardUpdate.disable = false
          })
          
        }
      } else {
        if (editionInfo.oldLoop !== editionInfo.newLoop) {
          for (const station of this.fluxData[editionInfo.oldLoop].stations) {
            if (station.name === editionInfo.oldWorkstation) {
              station.kanbanCards.filter( card => {
                if (card.code !== editionInfo.oldCode) {
                  return card
                } else {
                  cardUpdate = card
                }
              })
            }
          }
          this.fluxData[editionInfo.newLoop].stations[0].kanbanCards.push(cardUpdate)
          this.$nextTick(() => {
            cardUpdate.disable = false
          })
        }
      }
      this.$toasted.success('Modifications réalisées, elle s\'afficheront dans quelques secondes')
    },
    emitResetDisable (code) {
      for (const card of this.redBinKanbans.cards) {
        if (card.code === code) {
          card.disable = false
        }
      }
      for (const loop in this.fluxData){
        for (const station of this.fluxData[loop].stations) {
          for (const card of station.kanbanCards) {
            if (card.code === code) {
              card.disable = false
            }
          }
        }
      }
    },
    emitCloseModal () {
      this.updateData()
    },
    goToTracking (kanban) {
      if (!kanban.disable) {
       this.goTo('/tracking_order/' + kanban.code)
      }
    },
    displayDelay(since) {
      var now = moment()
      return now.diff(moment(since), 'minutes')
    },
    updateLoop (loopName, newLoopDescription) {
      const loop = this.fluxList.find(flux => flux.name === loopName)
      loop.description = newLoopDescription
      if (this.$refs['loop-' + loopName] && !_.isEmpty(this.$refs['loop-' + loopName])) {
        this.$refs['loop-' + loopName][0].refresh()
      }
    },
    updateData () {
      this.getAllWorkstations()
    },
    resetFluxData() {
      Object.keys(this.fluxData).forEach(key => {
        this.fluxData[key].stations.forEach(workstation => {
          workstation.kanbanCards = []
        })
      })
    },
    getAllDocumentsInfos() {
      let redbinKbCards = []
      server
        .getAllDocumentsInfo()
        .then(res => {
          this.resetFluxData()
          res.data.forEach(document => {
            if (document.blocked) {
              return
            }
            let kanbanCard = {}
            redbinKbCards = this.setKanbanCards(document,kanbanCard, redbinKbCards)
          })
          // We procced redBin data min max
          let min = -1
          let max = -1
          redbinKbCards.forEach(c => {
            min = (c.raw_lt < min || min == -1 ) ? c.raw_lt : min
            max = c.raw_lt > max ? c.raw_lt : max
          })
          this.redBinKanbans['cards'] = redbinKbCards
        })
        .then(() => {
          for (const flux of this.fluxList) {
            if (this.$refs['stations-' + flux.name] && !_.isEmpty(this.$refs['stations-' + flux.name])) {
              this.$refs['stations-' + flux.name][0].refresh()
            }
            this.isLoading = false
          }
          this.setProtectedTimeout(this.getAllDocumentsInfos, 60000 * 0.5)

        }).catch((error) => {
          this.isLoading = false
          console.error(error)
          this.error = `Une erreure s'est produite à la récupération des données. Vous pouvez nous contacter par mail : contact@aio.eu`
          this.setProtectedTimeout(this.getAllDocumentsInfos, 60000 * 5)
        })
    },
    setKanbanCards(document, kanbanCard,redbinKbCards){
      let loop = document.flux
      let workstation = document.workstation
      let workstation_position = document.workstation_position
      let isRedBin = true
      if (document.workstation_position > 0) {
        isRedBin = false
        workstation_position -= 1
      }
      if (!_.isEmpty(document.andon)) {
        kanbanCard.andonData = document.andon
        kanbanCard.andonDuration = this.displayDelay(
          document.andon.base.created_at
        )
      }
      kanbanCard.code = document.code
      kanbanCard.code_gex = document.code_gex,
      kanbanCard.raw_lt = parseFloat(document.lead_time)
      kanbanCard.leadTime = (document.lead_time / 3600).toFixed(2)
      kanbanCard.description = document.description
      kanbanCard.workstation = document.workstation
      kanbanCard.flux = document.flux
      kanbanCard.last_workstation = document.last_workstation
      kanbanCard.sdcd = document.sdcd
      kanbanCard.disable = false

      if (!isRedBin && this.fluxData[loop].stations[workstation_position]) {
        this.fluxData[loop].stations[workstation_position].kanbanCards.push(
          kanbanCard
        )
      } else if (isRedBin) {
        kanbanCard.workstation = workstation
        kanbanCard.loop = loop
        redbinKbCards.push(kanbanCard)
      }
      return redbinKbCards
    },
    str_pad_left (string, pad, length) {
      return (new Array(length + 1).join(pad) + string).slice(-length)
    },
    get_decimal_part (hours) {
      var day = 0.0
      day = (hours/24).toFixed(2)
      var dayDecimalTime = ''
      var finalDecimalTime = ' '
      var index = 0
      dayDecimalTime = day.toString()
      day = dayDecimalTime.split('')
      index = day.indexOf('.')
      finalDecimalTime = day[index + 1]
      return finalDecimalTime
    },
    getTime (timeInMin) {
      var finalTime = ''
      timeInMin = Math.round(timeInMin)
      var hours = Math.floor(timeInMin / 60)
      timeInMin = timeInMin - hours * 60
      var minutes = timeInMin
      finalTime = Math.floor(hours/24) + '.' + this.get_decimal_part(hours)
      if (finalTime %1 == 0) {
        finalTime = parseInt(finalTime)
      }
      return finalTime + ' j'
    },
    computeLeadTime(leadTimeList, nbDays) {
      let result = {}
      let date = new Date()
      let deltaTime = date.getDate() - nbDays
      date.setDate(deltaTime)
      let leadTimeInDeltaTime = leadTimeList
        .filter(leadTimeData => {
          if (leadTimeData.document != "80183850"){
            return new Date(leadTimeData.created_at) > date
          }
        })
        .map(leadTime => {
          return leadTime['lead_time']
        })
      if (!_.isEmpty(leadTimeInDeltaTime)) {
        const minLeadTime = _.min(leadTimeInDeltaTime) / 60
        const maxLeadTime = _.max(leadTimeInDeltaTime) / 60
        const leadTimeAvg = _.mean(leadTimeInDeltaTime) / 60

        const formattedLeadTimeAvg = this.getTime(leadTimeAvg)
        const formattedMinLeadTime = this.getTime(minLeadTime)
        const formattedMaxTimeAvg = this.getTime(maxLeadTime)

        result.leadTimeAvg = formattedLeadTimeAvg
        result.minLeadTime = formattedMinLeadTime
        result.maxLeadTime = formattedMaxTimeAvg
      }
      return result
    },
    getFluxStats(fluxName) {
      server.getLoopStats(fluxName).then(res => {
        Vue.set(this.fluxData[fluxName],'lastYearLeadTime',this.computeLeadTime(
          res.data,
          365
        ))
        Vue.set(this.fluxData[fluxName],'lastMonthLeadTime', this.computeLeadTime(
          res.data,
          30
        ))
        Vue.set(this.fluxData[fluxName],'lastWeekLeadTime', this.computeLeadTime(
          res.data,
          7
        ))
        this.updateNextTick()
      })
    },
    getRedbinThalesStats() {
      server.getRedbinThalesStats().then(res => {
        this.redBinKanbans['lastYearLeadTime'] = this.computeLeadTime(res.data, 365)
        this.redBinKanbans['lastMonthLeadTime'] = this.computeLeadTime(res.data, 30)
        this.redBinKanbans['lastWeekLeadTime'] = this.computeLeadTime(res.data, 7)
      })
    },
    getSingleFluxWorkstationsPromise(fluxName) {
      return server.getWorkstations(fluxName).then((result) => {
        this.fluxData[fluxName] = {
          lastYearLeadTime: {},
          lastMonthLeadTime: {},
          lastWeekLeadTime: {},
          stations: []
        }
        this.getFluxStats(fluxName)

        const lastStationPosition =  result.data.length -1
        result.data.forEach(workstation => {
          // No display red bin and last station
          if (workstation.position === 0 || workstation.position === lastStationPosition) {
            return
          }
          let station = {
            name: workstation.name,
            nbKanbanMax: workstation.max_documents,
            leadTimeTarget: workstation.max_lead_time,
            loop: workstation.loop_obj.name,
            position: workstation.position,
            kanbanCards: []
          }
          this.fluxData[fluxName].stations.push(station)
        })
        this.fluxData[fluxName].stations.sort(function (a, b) {
          return a.position < b.position ? -1 : 1
        })
      })
    },
    getAllWorkstations() {
      let i = 0
      const promises = []
      promises.push(this.getRedbinThalesStats())
      this.fluxList.forEach(flux => {
        promises.push(this.getSingleFluxWorkstationsPromise(flux.name))
      })
      Promise.all(promises).then(() => {
        this.getAllDocumentsInfos()
      }).catch((error) => {
        this.isLoading = false
        this.error = `Quelque chose c'est mal passé. Vous pouvez nous contacter par mail contact@aio.eu`
      })
    },
    getAllFlux() {
      server.getLoops().then((result) => {
        this.fluxList = result.data.sort((a, b) => a.index - b.index)
        this.getAllWorkstations()
        })
    },
    loader(statsDisplay, fluxName){
      if(this.fluxData[fluxName]["lastWeekLeadTime"]!=={} && this.fluxData[fluxName]["lastMonthLeadTime"]!=={} && this.fluxData[fluxName]["lastYearLeadTime"]!=={} && this.fluxData[fluxName]["stations"]!=={}){
        statsDisplay[fluxName] = true
      }
    },
    updateNextTick() {
      this.displayVue = false
      this.$nextTick().then(() => {
        this.displayVue = true
      })
    }
  },
  watch: {
  },
  mounted() {
    this.isLoading = true
    this.getAllFlux()
  },
  computed: {
    redbinKanbanInColumns () {
      const numberOfColumns = 4
      let columns = []
      let mid = Math.ceil(this.redBinKanbans.cards.length / numberOfColumns)
      for (let col = 0; col < numberOfColumns; col++){
        columns.push(this.redBinKanbans.cards.slice(col * mid, col * mid + mid))
      }
      return columns
    },
    getLeadTime(fluxName) {
      var stats = {}
      this.getFluxStats(fluxName)
        stats  = this.fluxData[fluxName] = {
          lastYearLeadTime: {},
          lastMonthLeadTime: {},
          lastWeekLeadTime: {},
        }
      return stats
    },
  }
}
</script>
<style>
  .thales-container{
    font-size: 1rem;
    font-weight: 600;
  }

  .vue-simple-context-menu__item.print::before {
    content: '\f02f';
    font-family: "FontAwesome";
    margin-right: 0.3rem;
  }

  .vue-simple-context-menu__item.edit::before {
    content: '\f040';
    font-family: "FontAwesome";
    margin-right: 0.3rem;
  }

  .vue-simple-context-menu__item.scan::before {
    content: '\f0ec';
    font-family: "FontAwesome";
    margin-right: 0.3rem;
  }
  .redbin-leadtime {
    font-size: 1.2rem;
    margin:0.2rem;
  }

  .pill-row{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

  }
  .sdcd-pill {
    background-color: white !important;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    margin-left: 1rem;
    margin-top: 0.3rem;
  }

  .styleGex {
    color: #565656;
  }


  @media screen and (min-width: 1919px) {
    .kanban-card.andon .kanban-card-id,
    .kanban-card.andon .kanban-lead-time,
    .flux-header, .kanban-card,
    .workstation-kanbans-number {
      font-weight: bold;
      font-size: 1.04rem;
    }
    /*.kanban-card.andon .kanban-card-id,
    .kanban-card.andon .kanban-lead-time,
    .kanban-card .kanban-card-id,
    .kanban-card .kanban-lead-time,
    .kanban-card .kanban-andon-duration{
      font-size: 1.2rem;
    }*/
  }
</style>



// WEBPACK FOOTER //
// src/components/NewHippodrome.vue